module.exports = __webpack_public_path__ + "img/vector_right.958452da.svg";